import { supabase } from '../supabase';
import { Database } from '../../types/database';

type Client = Database['public']['Tables']['clients']['Row'];
type ClientInsert = Database['public']['Tables']['clients']['Insert'];
type ClientUpdate = Database['public']['Tables']['clients']['Update'];

export const clientService = {
  /**
   * Get all clients (admin only)
   */
  getClients: async () => {
    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .order('created_at', { ascending: false });
    return { data, error };
  },

  /**
   * Get client by ID
   */
  getClientById: async (id: string) => {
    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .eq('id', id)
      .single();
    return { data, error };
  },

  /**
   * Get client by email
   */
  getClientByEmail: async (email: string) => {
    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .eq('email', email)
      .single();
    return { data, error };
  },

  /**
   * Create a new client
   */
  createClient: async (client: Omit<ClientInsert, 'id' | 'created_at' | 'updated_at'>) => {
    const { data, error } = await supabase
      .from('clients')
      .insert(client)
      .select()
      .single();
    return { data, error };
  },

  /**
   * Update an existing client
   */
  updateClient: async (id: string, updates: ClientUpdate) => {
    const { data, error } = await supabase
      .from('clients')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    return { data, error };
  },

  /**
   * Delete a client
   */
  deleteClient: async (id: string) => {
    const { data, error } = await supabase
      .from('clients')
      .delete()
      .eq('id', id)
      .select()
      .single();
    return { data, error };
  },

  /**
   * Search clients by name or company
   */
  searchClients: async (query: string) => {
    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .or(`name.ilike.%${query}%,company.ilike.%${query}%,email.ilike.%${query}%`)
      .order('created_at', { ascending: false });
    return { data, error };
  }
};